import { render, staticRenderFns } from "./TwentyTwenty.vue?vue&type=template&id=e880b49e&"
import script from "./TwentyTwenty.vue?vue&type=script&lang=js&"
export * from "./TwentyTwenty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports